import React from 'react';

import Totalizer from './Totalizer';
import './style.css';

class Totalizers extends React.Component {
  render() {
    const {
      title,
      totalizers,
    } = this.props;

    return (
      <div className="Totalizers__root">
        {totalizers && <Totalizer name={title} total={totalizers} />}
      </div>
    );
  }
}

export default Totalizers;
